import { Component, OnInit, ViewChild } from '@angular/core';
import { AdmEquipeService } from 'src/app/shared/api/adm-equipe.service';
import { ClientesService } from 'src/app/shared/api/clientes.service';
import { AdmLicencasService } from 'src/app/shared/api/licencas/adm-licencas.service';
import { TestesAtivosService } from 'src/app/shared/api/testes/testes.service';
import { IFilterComponentConfiguration } from 'src/app/shared/components/filter-component/filter-component.component';
import { TableListComponent } from 'src/app/shared/components/table-list/table-list.component';
import { dateToEnglishDateString } from 'src/app/shared/functions/data-transform';
import { ColumnDataType } from 'src/app/shared/model/resource';
import { licencasResource } from './licencas.resource';

@Component({
    selector: 'app-adm-licencas',
    templateUrl: './adm-licencas.component.html',
    styleUrls: ['./adm-licencas.component.css']
})
export class AdmLicencasComponent implements OnInit {
    @ViewChild('listagemLicencas') listagemLicencas!: TableListComponent;

    licencasResource = licencasResource;

    filterConfiguration!: IFilterComponentConfiguration;

    clienteId: string | null = null;

    constructor(
        public admLicencasService: AdmLicencasService,
        public testesAdmService: TestesAtivosService,
        private admEquipeService: AdmEquipeService
    ) { }

    ngOnInit(): void {
        this.testesAdmService.setBaseUrl({ativo: true});
        this.configureFilters();
    }

    private configureFilters() {
        this.filterConfiguration = {
            colunas: [
                {
                    field: 'teste',
                    label: 'MindTest',
                    type: ColumnDataType.Lookup,
                    lookupConfiguration: {
                        colunas: [
                            {
                                field: 'nome',
                                label: 'Nome',
                                required: true
                            },
                            {
                                field: 'descricao',
                                label: 'Descrição',
                                required: true
                            }
                        ],
                        fieldName: 'nome',
                        fieldPk: 'uuid',
                        instanciaService: this.testesAdmService
                    },
                    sizeColumn: 'col-xl-4'
                },
                {
                    field: 'data_inicio_de',
                    label: 'Data início (de)',
                    type: ColumnDataType.Date,
                    sizeColumn: 'col-xl-2 col-lg-3 col-md-4',
                    getValueBeforSave: dateToEnglishDateString
                },
                {
                    field: 'data_inicio_ate',
                    label: 'Data início (até)',
                    type: ColumnDataType.Date,
                    sizeColumn: 'col-xl-2 col-lg-3 col-md-4',
                    getValueBeforSave: dateToEnglishDateString
                },
                {
                    field: 'data_fim_de',
                    label: 'Data fim (de)',
                    type: ColumnDataType.Date,
                    sizeColumn: 'col-xl-2 col-lg-3 col-md-4',
                    getValueBeforSave: dateToEnglishDateString
                },
                {
                    field: 'data_fim_ate',
                    label: 'Data fim (até)',
                    type: ColumnDataType.Date,
                    sizeColumn: 'col-xl-2 col-lg-3 col-md-4',
                    getValueBeforSave: dateToEnglishDateString
                },
                {
                    field: 'dono',
                    label: 'Cliente',
                    type: ColumnDataType.Lookup,
                    sizeColumn: 'col-xl-4',
                    lookupConfiguration: {
                        colunas: [
                            {
                                field: 'nome_fantasia',
                                label: 'Cliente',
                                required: true
                            },
                            {
                                field: 'cnpj',
                                label: 'CNPJ',
                                required: true
                            }
                        ],
                        fieldName: 'nome_fantasia',
                        fieldPk: 'uuid',
                        service: ClientesService
                    },
                    onChange(entity) {
                        entity.equipe = null;
                    },
                },
                {
                    field: 'equipe',
                    label: 'Equipe',
                    type: ColumnDataType.Lookup,
                    sizeColumn: 'col-xl-4',
                    showCampoFormulario(entity) {
                        return entity.dono?.uuid != null;
                    },
                    lookupConfiguration: {
                        colunas: [
                            {
                                field: 'nome',
                                label: 'Equipe',
                                required: true
                            }
                        ],
                        fieldName: 'nome',
                        fieldPk: 'uuid',
                        instanciaService: this.admEquipeService
                    }
                },
                {
                    field: 'concluido',
                    label: 'Concluídas',
                    type: ColumnDataType.Checkbox,
                    sizeColumn: 'col-xl-2 col-lg-3 col-md-4'
                }
            ],
            tratarValoresFiltrar: ($event: any) => {
                const filtro: any = {};
                if (!$event) return filtro;
                if ($event.teste) filtro['teste'] = $event.teste.uuid;
                if ($event.data_inicio_de) filtro['data_inicio_de'] = $event.data_inicio_de;
                if ($event.data_inicio_ate) filtro['data_inicio_ate'] = $event.data_inicio_ate;
                if ($event.data_fim_de) filtro['data_fim_de'] = $event.data_fim_de;
                if ($event.data_fim_ate) filtro['data_fim_ate'] = $event.data_fim_ate;
                if ($event.dono) filtro['dono'] = $event.dono.uuid;
                if ($event.equipe) filtro['equipe'] = $event.equipe.uuid;
                if ($event.concluido) filtro['concluido'] = $event.concluido;

                // setar o id do cliente para tratar quando deve exibir o filtro de equipes e para passar para os serviços que necessitam do id do cliente
                if($event.dono) {
                    this.clienteId = $event.dono.uuid;
                    this.admEquipeService.setBaseUrl($event.dono.uuid);
                }
                else {
                    this.clienteId = null;
                    this.admEquipeService.setBaseUrl(undefined as any);
                }

                filtro['em_uso'] = true;
                return filtro;
            }
        };
    }
}
